"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _LogisticTaskComponent.default;
  }
});

var _LogisticTaskComponent = _interopRequireDefault(require("./LogisticTask-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }